import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
export async function captcha() {
  return axios.post('/captcha');
}
export const useCaptcha = ({
  config
}) => {
  return useQuery({
    queryKey: ['captcha'],
    queryFn: () => captcha(),
    ...config
  });
};